export default "__VITE_ASSET__2d78ea7f__"